import overrideOptions from '$utils/overrideOptions';

const mergeGradesWithOverride = (overrides) => (grade) => {
  const studentOverride = overrides.find(
    ({ studentId }) => studentId === grade.studentId
  );

  if (!studentOverride || !overrideOptions[studentOverride.code]) {
    return grade;
  }

  return {
    ...grade,
    displayGrade: overrideOptions[studentOverride.code],
  };
};

export default mergeGradesWithOverride;
